module.exports = __webpack_public_path__ + "media/images/bg-header-wave-reverse-40cac0c29f6f4723b820ac9563fe8924.png";